<div class="sm:flex sm:items-center">
  <div class="inline-flex w-full">
    <h1 class="font-semibold leading-6 text-gray-900 !text-3xl inline-flex">
      <span class="place-self-end">{{ title }}</span>
    </h1>
    <ng-content></ng-content>
  </div>
</div>
